

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./SlideShop.Validator.js"

class SlideShopAPI {

  /*
    POST http://localhost:3000/slideShop/create
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

    {
        "productName":"test",
        "productId":"5435435",
        "slideMobiles":["url image 1"],
        "slidePcs":["url image 3"],
        "extraInfo":{
            "sale":50
        }
    }
  */

  create = async (data) => {
    const validator = Validator.VALIDATION_SLIDESHOP_CREATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/slideShop/create", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    POST http://localhost:3000/slideShop/update
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

    {
        "id":"576932278794",
        "productName":"test update",
        "productId":"5435435",
        "slideMobiles":["url image 1"],
        "slidePcs":["url image 3"],
        "extraInfo":{
            "sale":50
        }
    }
  */

  update = async (data) => {
    const validator = Validator.VALIDATION_SLIDESHOP_UPDATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/slideShop/update", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    POST http://localhost:3000/slideShop/delete
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

    {
        "id":"299729139440"
    }
  */

  delete = async (data) => {
    const validator = Validator.VALIDATION_SLIDESHOP_DELETE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/slideShop/delete", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  /*
    POST http://api.houselink.com:3000/rating/list
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

    {
        "objectId":"783449412431"
    }
  * */
  list = async (data) => {
    const validator = Validator.VALIDATION_SLIDESHOP_LIST;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/slideShop/list", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

}
export default new SlideShopAPI();



// WEBPACK FOOTER //
// ./src/services/slideShop/SlideShop.API.js